'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupShow = popupShow;
exports.popupCloseLast = popupCloseLast;

var _actionTypes = require('../constants/actionTypes');

function popupShow(type, data) {
  return {
    type: _actionTypes.POPUP_SHOW,
    popupType: type,
    popupData: data
  };
}
/* injects from baggage-loader */

function popupCloseLast() {
  return {
    type: _actionTypes.POPUP_CLOSE_LAST
  };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/popupActions.js
// module id = 101
// module chunks = 1